import React, { useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { InternationalCallsFilter } from "./internationalCalls-filter/InternationalCallsFilter";
import { InternationalCallsTable } from "./internationalCalls-table/InternationalCallsTable";
import { InternationalCallsGrouping } from "./internationalCalls-grouping/InternationalCallsGrouping";
import { useInternationalCallsUIContext } from "./InternationalCallsUIContext";
import { useSelector, shallowEqual } from "react-redux";

export function InternationalCallsCard() {
  const internationalCallsUIContext = useInternationalCallsUIContext();
  const internationalCallsUIProps = useMemo(() => {
    return {
      ids: internationalCallsUIContext.ids,
    };
  }, [internationalCallsUIContext]);


   const { currentState } = useSelector(
      (state) => ({ currentState: state.internationalCalls }),
      shallowEqual
    );
    const { data } = currentState;

  return (

<Card>
  <CardHeader className="noborder">
    <div>
      <h1 className="title pt-5" style={{ margin: 0 }}>
       {data?.lowerTitle || ""}
      </h1>
      <p className="sub-title py-3" style={{ margin: 0 }}>
        {data?.lowerDescription || ""}
      </p>
    </div>
    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px",width:"100%"}}>
      <CardHeaderToolbar>
        <InternationalCallsFilter />
      </CardHeaderToolbar>
    </div>
  </CardHeader>
  <CardBody className="callbody">
    {/* {internationalCallsUIProps.ids.length > 0 && <InternationalCallsGrouping />} */}
    <InternationalCallsTable />
  </CardBody>
</Card>
  );
}
